import React, { useState, useEffect } from "react";
import {
  Table,
  Typography,
  Button,
  Tag,
  Input,
  Row,
  Col,
  Card,
  DatePicker,
  Select,
} from "antd";
import Spinner from "../components/Spinner";
import moment from "moment";
import { getRslBalanceReport, getRslOrderReport } from "../api/api";
import dayjs from "dayjs";
import CustomerName from "../components/CustomerName";
import { Link } from "react-router-dom";
import Status from "../components/Status";
const { Column } = Table;
const { Text } = Typography;

export default function RslBalanceReport() {
  const [data, setData] = useState(null);
  const [stats, setStats] = useState({});
  const [filter, setFilter] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setData(null);
    let finalFilter = {};
    getRslBalanceReport((mData) => {
      setData(mData);
      let prev = { ...mData };
      delete prev.customers;
      setStats(prev);
    }, filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const statsStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "black",
    padding: "1rem",
    backgroundColor: "white",
    width: "220px",
    justifyContent: "center",
  };

  console.log(stats);

  function camelToTitle(str) {
    return str
      .replace(/([A-Z])/g, " $1") // space before capital
      .replace(/^./, (s) => s.toUpperCase()); // uppercase first letter
  }

  function toTitleCase(str) {
    return str
      .replace(/_/g, " ") // replace underscores with space
      .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letter of each word
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          marginBottom: "1rem",
          flexWrap: "wrap",
          gap: 8,
          marginTop: 8,
        }}
        className="statusGrid report"
      >
        {data && stats && (
          <>
            {Object.entries(stats).map(([key, value]) => (
              <div key={key} style={statsStyle}>
                <Text
                  style={{ fontSize: 15, color: "gray", textAlign: "center" }}
                >
                  {toTitleCase(key)}
                </Text>
                <Text style={{ fontSize: 18, fontWeight: "bold" }}>
                  {value.toLocaleString()}
                </Text>
              </div>
            ))}
          </>
        )}
      </div>
      <div>
        {data ? (
          <div>
            <Table
              dataSource={data.customers}
              rowKey={(record) => record.date}
              pagination={{
                pageSize: 500,
                showSizeChanger: false,
              }}
              bordered
              onChange={(pagination, filters, sorter) => {
                // scroll to top when page changes
                window.scrollTo({ top: 0 });
              }}
            >
              <Column
                title="Join Date"
                dataIndex="date"
                render={(text, record, index) => (
                  <Text>{moment(record.createdAt).format("DD/MM/YYYY")}</Text>
                )}
              />
              <Column
                title="Customer"
                dataIndex="date"
                render={(text, record, index) => (
                  <div>
                    <CustomerName
                      data={{
                        name: record.name,
                        badge: record.badge,
                        _id: record._id,
                        phone: record.phone,
                        country: record.country,
                        email: record.email,
                      }}
                      withBadge={true}
                    />
                  </div>
                )}
              />

              <Column
                title="Balance"
                dataIndex="date"
                render={(text, record, index) => (
                  <Text type="danger">
                    ৳{record.balance ? record.balance?.toLocaleString() : 0}
                  </Text>
                )}
              />
            </Table>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
}
